import axios from "./axios-config";

export const getAllProvinces = async () => {

    let { data } = await axios.get(`/super-admin/provinces`)
    return (data);

}
export const getProvinceCities = async (id) => {

    let { data } = await axios.get(`/super-admin/cities/`+id)
    return (data);

}